import React, { useState } from "react";
// import values from "../../../../values";

import { Container } from "react-bootstrap";
import {
  BreadCrumb,
  CustomButton2,
  CustomView,
  Pagination,
  TableHeader,
  TableLoading,
} from "../../../../components";
import values from "../../../../values";
import { Components } from "./components";
import "./index.scss";
import Context from "../../../../context";
import { useTranslation } from "react-i18next";

type Props = {
  rqData: any;
  showModalData: any;
};

const ParentTransactionScreen = (props: Props) => {
  const { requestParentTransaction, setRequestParentTransaction,setShowModal } = React.useContext(
    Context.ParentTransactionScreen
  );

  const { t } = useTranslation();


  return (
    <section id="transactions-screen">
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column extraLarge={4} large={5} medium={7} className="search-and-filter-wrapper">
          <Components.Filter />
          <Components.Search />
        </CustomView.Column>
      </CustomView.Row>
      <Container>
        <div className="table-content-wrapper">
          <table>
            <TableHeader headers={values.tableHeaders.PARENT_TRANSACTION.map((item) => t(item))}/>
            {props.rqData?.status === "loading" ? (<TableLoading />) : (<Components.Body data={props.rqData} />)}
          </table>
        </div>
        <div
          style={{display: "flex", justifyContent: "center", marginTop: "2rem", gap: "1rem",}}>
          <div></div>
        </div>
      </Container>
      {props.rqData?.status === "success" &&
        props.rqData?.data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={requestParentTransaction?.page}
              totalPages={props.rqData?.data?.result?.totalPages}
              onPaginate={(page: number) => setRequestParentTransaction({...requestParentTransaction, page: page,})}
            />
          </div>
        )}
    </section>
  );
};

export default ParentTransactionScreen;
